export function getAll() {
  return [
    {
      value: 0,
      name: "B2C",
      text: "個人",
    },
    {
      value: 1,
      name: "B2B",
      text: "公司",
    },
    {
      value: 3,
      name: "GovernmentOrEducation",
      text: "政府機關／教育機構",
    },
  ];
}
